export default __webpack_public_path__ + "static/jerrel2-3171453c4ac77d56dc407057baf3418e.png";